module.exports = __webpack_public_path__ + "img/1559940569.5d25fb8b.jpg";